export default "__VITE_ASSET__270914fe__"